import { FC } from 'react'
import GoogleMapReact from 'google-map-react'
import styles from './mapStyles.json'
import { PositionsWithProducers, ProducerMapProps as Props } from './types'
import ProducerMarker from './ProducerMarker'
import { GMAPS_API_KEY } from 'constants/envs'

const ProducerMap: FC<Props> = ({
  producers,
  activeProducerId,
  activePositionIndex,
  popupProducerId,
  popupPositionIndex,
  onMouseEnter,
  onMouseLeave,
  height,
  zoom,
  center,
  enablePanning,
  onBoundsChange,
  onClick
}) => {
  /**
   * Returns the sorted positions
   *
   * @returns PositionsWithProducers[]
   */
  const getSortedPositions = (): PositionsWithProducers[] => {
    // Filter the producers with positions
    const producersWithPositions = producers.filter((producer) => producer.positions.length > 0)

    // Reduce the producersWithPositions to an array of PositionsWithProducers objects
    const positionsWithProducerInfo = producersWithPositions.reduce((positionsWithProducer, producer, index) => {
      producer.positions.forEach((position) => {
        positionsWithProducer.push({ producer, index, position })
      })

      return positionsWithProducer
    }, [] as PositionsWithProducers[])

    // Sort & return the positionsWithproducers
    return positionsWithProducerInfo.slice().sort((a, b) => {
      if (
        (a.producer.id === popupProducerId && a.index === popupPositionIndex) ||
        (a.producer.id === activeProducerId && a.index === activePositionIndex)
      ) {
        return 1
      }

      if (
        (b.producer.id === popupProducerId && b.index === popupPositionIndex) ||
        (b.producer.id === activeProducerId && b.index === activePositionIndex)
      ) {
        return -1
      }

      return 0
    })
  }

  return (
    <div style={{ height, width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: GMAPS_API_KEY }}
        center={center}
        defaultZoom={zoom}
        options={{
          styles,
          scrollwheel: false,
          gestureHandling: enablePanning ? 'greedy' : 'cooperative'
        }}
        onClick={() => onClick && onClick()}
        onChange={(e) => onBoundsChange && onBoundsChange(e.bounds)}
      >
        {getSortedPositions().map(({ position, index, producer }) => {
          if (!Number.isNaN(position.lat) && !Number.isNaN(position.lng)) {
            return (
              <ProducerMarker
                key={`${producer.id}${index}`}
                producer={producer}
                lat={position.lat}
                lng={position.lng}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
                active={activeProducerId === producer.id && activePositionIndex === index}
                popup={popupProducerId === producer.id && popupPositionIndex === index}
              />
            )
          }

          return null
        })}
      </GoogleMapReact>
    </div>
  )
}

ProducerMap.defaultProps = {
  center: {
    lat: 50.943383,
    lng: 3.928225
  },
  zoom: 8,
  height: '100%'
}

export default ProducerMap
